import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Input } from "@progress/kendo-react-inputs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { connect } from "react-redux";
import { getEnterpriseByEmail } from "../../redux/actions/enterpriseActions";
import { getByEmail as getUserDetail } from "../../redux/actions/userActions";
import { get as getState } from "../../redux/actions/stateActions";
import Moment from "react-moment";
import { dateFormat } from "../../constants";
import { Avatar } from "@material-ui/core";
import "../../../src/css/avatar.css";
import { InputDatePicker } from "../../components/Input";
import { getter } from "@progress/kendo-react-common";

const enableDtGetter = getter("enableDateTimeExpire");
const pauseDtGetter = getter("pauseDateTimeExpire");
const compareDateValidator = (values) => {
  if (enableDtGetter(values) === undefined && pauseDtGetter(values) === undefined)
    return;
  if (enableDtGetter(values) === undefined && pauseDtGetter(values) !== undefined)
    return {
      enableDateTimeExpire: "Enable date must be provided.",
    };

  if (enableDtGetter(values) !== undefined && pauseDtGetter(values) === undefined)
    return {
      pauseDateTimeExpire: "Pause date must be provided.",
    };

  if (
    enableDtGetter(values) !== "" &&
    pauseDtGetter(values) !== "" &&
    enableDtGetter(values) >= pauseDtGetter(values)
  )
    return {
      enableDateTimeExpire: "Enable date must earlier than pause date.",
    };

  return;
};

class UserDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: null,
      entid: null,
      isGodMode: false,
    };
  }

  componentDidMount() {
    this.props.getEnterpriseByEmail(this.props.user.email);
    let interval = setInterval(() => {
      if (!this.props.enterprisePending) {
        this.setState({
          isGodMode: this.props.isGodMode,
          email: this.props.user.email,
          entid:
            this.props.enterprises.length === 0
              ? 0
              : this.props.enterprises[0].id,
        });
        clearInterval(interval);
      }
    }, 100);
  }

  EnableDatePicker = (props) => {
    return (
      <InputDatePicker
        {...props}
        defaultValue={new Date(this.state.enableDateTimeExpire)}
      />
    );
  };

  PauseDatePicker = (props) => {
    return (
      <InputDatePicker
        {...props}
        defaultValue={new Date(this.state.pauseDateTimeExpire)}
      />
    );
  };

  componentWillUnmount() { }

  handleCountriesChange = (event) => {
    this.props.getState(event.target.value);
    let interval = setInterval(() => {
      if (!this.props.statesPending) {
        let temp = [];
        this.props.states.map((item, idx) => {
          temp.push(item.name);
          return item;
        });
        this.setState({ states: temp, state: "", country: event.value });
        clearInterval(interval);
      }
    }, 100);
  };

  handleEnterpriseChange = (event) => {
    this.setState({ email: this.props.user.email, entid: event.value.id });
  };

  handleCancel = (event) => {
    this.props.closeDetail();
  };

  handleClose = (event) => {
    this.props.closeDetail();
  };

  handleEdit = (event) => {
    this.props.getUserDetail(this.props.user.email);
    let interval = setInterval(() => {
      if (!this.props.userPending) {
        this.setState({
          salutation: this.props.data.profile.salutation,
          username: this.props.data.profile.username,
          firstname: this.props.data.profile.firstname,
          middlename: this.props.data.profile.middlename,
          lastname: this.props.data.profile.lastname,
          mobile: this.props.data.profile.mobile,
          street1: this.props.data.profile.street1,
          street2: this.props.data.profile.street2,
          suburb: this.props.data.profile.suburb,
          postcode: this.props.data.profile.postcode,
          state: this.props.data.profile.state,
          country: this.props.data.profile.country,
          enableDateTimeExpire: this.props.data.profile.enableDateTimeExpire,
          pauseDateTimeExpire: this.props.data.profile.pauseDateTimeExpire,
          countries: this.props.data.countries,
          states: this.props.data.states,
        });
        this.props.editDetail();
        clearInterval(interval);
      }
    }, 100);
  };

  handleSwitch = (event) => {
    this.props.switchDetail();
  };

  handleDelete = () => {
    let data = null;
    if (this.state.isGodMode) {
      data = { email: this.state.email, entid: this.state.entid };
    } else {
      data = { email: this.props.user.email, entid: this.state.entid };
    }
    this.props.deleteDetail(data);
  };

  handleSubmit = (event) => {
    let data = {
      Email: this.props.user.email,
      salutation:
        event.salutation === undefined
          ? this.state.salutation
          : event.salutation,
      username: event.username === undefined ? this.state.username : event.username,
      firstname:
        event.firstname === undefined ? this.state.firstname : event.firstname,
      middlename:
        event.middlename === undefined
          ? this.state.middlename
          : event.middlename,
      lastname:
        event.lastname === undefined ? this.state.lastname : event.lastname,
      Mobile: event.mobile === undefined ? this.state.mobile : event.mobile,
      Street1: event.street1 === undefined ? this.state.street1 : event.street1,
      Street2: event.street2 === undefined ? this.state.street2 : event.street2,
      Suburb: event.suburb === undefined ? this.state.suburb : event.suburb,
      Postcode:
        event.postcode === undefined ? this.state.postcode : event.postcode,
      State: event.state === undefined ? this.state.state : event.state,
      Country: event.country === undefined ? this.state.country : event.country,
      EnableDateTimeExpire:
        event.enableDateTimeExpire === undefined
          ? this.state.enableDateTimeExpire
          : event.enableDateTimeExpire,
      PauseDateTimeExpire:
        event.pauseDateTimeExpire === undefined
          ? this.state.pauseDateTimeExpire
          : event.pauseDateTimeExpire,
    };
    this.props.updateDetail(data);
  };

  render() {
    let userDetail;
    if (this.state.isGodMode)
      if (this.props.isEditMode) {
        userDetail = (
          <div>
            <Dialog
              title={this.props.user.fullName}
              onClose={this.props.closeDetail}
            >
              <div style={{ width: "600px" }}>
                <Form
                  key={uuidv4()}
                  validator={compareDateValidator}
                  onSubmit={this.handleSubmit}
                  render={(formRenderProps) => (
                    <FormElement>
                      <fieldset className={"k-form-fieldset"}>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td align={"center"} colSpan={3}>
                                {this.props.user.avatar == null ? (
                                  <Avatar
                                    alt="{fullname}"
                                    className={"MuiAvatar-View"}
                                    src="/static/img/avatars/nophoto.jpg"
                                  />
                                ) : (
                                  <Avatar
                                    alt="{fullname}"
                                    className={"MuiAvatar-View"}
                                    src={this.props.user.avatar}
                                  />
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Username</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>{this.props.user.username}</td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Email</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>{this.props.user.email}</td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Firstname</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Field
                                  name={"firstname"}
                                  type={"text"}
                                  defaultValue={this.state.firstname}
                                  component={Input}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Middlename</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Field
                                  name={"middlename"}
                                  type={"text"}
                                  defaultValue={this.state.middlename}
                                  component={Input}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Lastname</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Field
                                  name={"lastname"}
                                  type={"text"}
                                  defaultValue={this.state.lastname}
                                  component={Input}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Mobile</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Field
                                  name={"mobile"}
                                  type={"text"}
                                  defaultValue={this.state.mobile}
                                  component={Input}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td valign="top">
                                <label>
                                  <b>Address</b>
                                </label>
                              </td>
                              <td valign="top">
                                <label>:</label>
                              </td>
                              <td>
                                <Field
                                  name={"street1"}
                                  type={"text"}
                                  defaultValue={this.state.street1}
                                  component={Input}
                                />
                                <Field
                                  name={"street2"}
                                  type={"text"}
                                  defaultValue={this.state.street2}
                                  component={Input}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Suburb</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Field
                                  name={"suburb"}
                                  type={"text"}
                                  defaultValue={this.state.suburb}
                                  component={Input}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Postcode</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Field
                                  name={"postcode"}
                                  type={"text"}
                                  defaultValue={this.state.postcode}
                                  component={Input}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>State</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td valign="top">
                                <Field
                                  component={DropDownList}
                                  data={this.state.states}
                                  name={"state"}
                                  defaultValue={this.state.state}
                                  filterable={false}
                                  disabled={false}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Country</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td valign="top">
                                <Field
                                  component={DropDownList}
                                  data={this.state.countries}
                                  onChange={this.handleCountriesChange}
                                  name={"country"}
                                  defaultValue={this.state.country}
                                  filterable={false}
                                  disabled={false}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Enable</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                {this.props.user.enable ? (
                                  <label>Yes</label>
                                ) : (
                                  <label>No</label>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Enable Date Expire</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Field
                                  id={"enableDateTimeExpire"}
                                  name={"enableDateTimeExpire"}
                                  component={this.EnableDatePicker}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Pause Date Expire</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Field
                                  id={"pauseDateTimeExpire"}
                                  name={"pauseDateTimeExpire"}
                                  component={this.PauseDatePicker}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>&nbsp;</td>
                            </tr>
                            <tr>
                              <td colSpan={3}>
                                <div className="k-form-buttons">
                                  {!this.props.isDeleteMode &&
                                    this.props.isEditMode && (
                                      <>
                                        <button
                                          type="submit"
                                          className="k-button k-primary"
                                          disabled={!this.props.canUpdate}
                                        >
                                          <div>Update</div>
                                        </button>
                                        <button
                                          type={"submit"}
                                          className="k-button"
                                          onClick={this.handleSwitch}
                                        >
                                          Cancel
                                        </button>
                                      </>
                                    )}
                                  {!this.props.isDeleteMode &&
                                    !this.props.isEditMode && (
                                      <>
                                        <button
                                          type="submit"
                                          className="k-button k-primary"
                                          disabled={!this.props.canUpdate}
                                          onClick={this.handleEdit}
                                        >
                                          <div>Edit</div>
                                        </button>
                                        <button
                                          type="submit"
                                          className="k-button"
                                          onClick={this.handleClose}
                                          disabled={!this.props.canUpdate}
                                        >
                                          <div>Close</div>
                                        </button>
                                      </>
                                    )}
                                  {this.props.isDeleteMode && (
                                    <>
                                      <button
                                        type={"submit"}
                                        className="k-button k-primary"
                                        onClick={this.handleDelete}
                                        disabled={!this.props.canDelete}
                                      >
                                        <div>Delete</div>
                                      </button>
                                      <button
                                        type={"submit"}
                                        className="k-button"
                                        onClick={this.handleCancel}
                                      >
                                        Cancel
                                      </button>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </fieldset>
                    </FormElement>
                  )}
                />
              </div>
            </Dialog>
          </div>
        );
      } else {
        userDetail = (
          <div>
            <Dialog
              title={this.props.user.fullName}
              onClose={this.props.closeDetail}
            >
              <div style={{ width: "500px" }}>
                <Form
                  key={uuidv4()}
                  validator={compareDateValidator}
                  onSubmit={this.handleSubmit}
                  initialValues={{
                    enterprises:
                      this.props.enterprises == null
                        ? []
                        : this.props.enterprises[0],
                  }}
                  render={(formRenderProps) => (
                    <FormElement>
                      <fieldset className={"k-form-fieldset"}>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td align={"center"} colSpan={3}>
                                {this.props.user.avatar == null ? (
                                  <Avatar
                                    alt="{fullname}"
                                    className={"MuiAvatar-View"}
                                    src="/static/img/avatars/nophoto.jpg"
                                  />
                                ) : (
                                  <Avatar
                                    alt="{fullname}"
                                    className={"MuiAvatar-View"}
                                    src={this.props.user.avatar}
                                  />
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Email</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>{this.props.user.email}</td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Mobile</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <span>{this.props.user.mobile}</span>
                              </td>
                            </tr>
                            <tr>
                              <td valign="top">
                                <label>
                                  <b>Address</b>
                                </label>
                              </td>
                              <td valign="top">
                                <label>:</label>
                              </td>
                              <td>
                                <span>{this.props.user.address}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Suburb</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <span>{this.props.user.suburb}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Postcode</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <span>{this.props.user.postcode}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>State</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>{this.props.user.state}</td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Role</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>{this.props.user.count}</td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Date Joined</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Moment
                                  format={dateFormat}
                                  date={
                                    new Date(this.props.user.dateTimeCreated)
                                  }
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Is Hygeian</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                {this.props.user.isHygeian ? (
                                  <label>Yes</label>
                                ) : (
                                  <label>No</label>
                                )}
                              </td>
                            </tr>
                            {this.props.isDeleteMode && (
                              <tr>
                                <td>
                                  <label>
                                    <b>Enterprisesa</b>
                                  </label>
                                </td>
                                <td>
                                  <label>:</label>
                                </td>
                                <td>
                                  <Field
                                    component={DropDownList}
                                    data={this.props.enterprises}
                                    name={"enterprises"}
                                    textField={"name"}
                                    dataItemKey={"id"}
                                    onChange={this.handleEnterpriseChange}
                                    filterable={false}
                                    disabled={false}
                                  />
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td>
                                <label>
                                  <b>Enable</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                {this.props.user.enable ? (
                                  <label>Yes</label>
                                ) : (
                                  <label>No</label>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Enable Date Expire</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Moment
                                  format={dateFormat}
                                  date={
                                    new Date(
                                      this.props.user.enableDateTimeExpire
                                    )
                                  }
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <b>Pause Date Expire</b>
                                </label>
                              </td>
                              <td>
                                <label>:</label>
                              </td>
                              <td>
                                <Moment
                                  format={dateFormat}
                                  date={
                                    new Date(
                                      this.props.user.pauseDateTimeExpire
                                    )
                                  }
                                />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3}>&nbsp;</td>
                            </tr>
                            <tr>
                              <td colSpan={3}>
                                <div className="k-form-buttons">
                                  {!this.props.isDeleteMode &&
                                    this.props.isEditMode && (
                                      <>
                                        <button
                                          type="submit"
                                          className="k-button k-primary"
                                          disabled={!this.props.canUpdate}
                                        >
                                          <div>Update</div>
                                        </button>
                                        <button
                                          type={"submit"}
                                          className="k-button"
                                          onClick={this.handleSwitch}
                                        >
                                          Cancel
                                        </button>
                                      </>
                                    )}
                                  {!this.props.isDeleteMode &&
                                    !this.props.isEditMode && (
                                      <>
                                        <button
                                          type="submit"
                                          className="k-button k-primary"
                                          disabled={!this.props.canUpdate}
                                          onClick={this.handleEdit}
                                        >
                                          <div>Edit</div>
                                        </button>
                                        <button
                                          type="submit"
                                          className="k-button"
                                          onClick={this.handleClose}
                                          disabled={!this.props.canUpdate}
                                        >
                                          <div>Close</div>
                                        </button>
                                      </>
                                    )}
                                  {this.props.isDeleteMode && (
                                    <>
                                      <button
                                        type={"submit"}
                                        className="k-button k-primary"
                                        onClick={this.handleDelete}
                                        disabled={!this.props.canDelete}
                                      >
                                        <div>Delete</div>
                                      </button>
                                      <button
                                        type={"submit"}
                                        className="k-button"
                                        onClick={this.handleCancel}
                                      >
                                        Cancel
                                      </button>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </fieldset>
                    </FormElement>
                  )}
                />
              </div>
            </Dialog>
          </div>
        );
      }
    else
      userDetail = (
        <div>
          <Dialog
            title={this.props.user.fullName}
            onClose={this.props.closeDetail}
          >
            <div style={{ width: "500px" }}>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td align={"center"} colSpan={3}>
                      {this.props.user.avatar == null ? (
                        <Avatar
                          alt="{fullname}"
                          className={"MuiAvatar-View"}
                          src="/static/img/avatars/nophoto.jpg"
                        />
                      ) : (
                        <Avatar
                          alt="{fullname}"
                          className={"MuiAvatar-View"}
                          src={this.props.user.avatar}
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <b>Email</b>
                      </label>
                    </td>
                    <td>
                      <label>:</label>
                    </td>
                    <td>{this.props.user.email}</td>
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <b>Mobile</b>
                      </label>
                    </td>
                    <td>
                      <label>:</label>
                    </td>
                    <td>{this.props.user.mobile}</td>
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <b>Address</b>
                      </label>
                    </td>
                    <td>
                      <label>:</label>
                    </td>
                    <td>{this.props.user.address}</td>
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <b>Suburb</b>
                      </label>
                    </td>
                    <td>
                      <label>:</label>
                    </td>
                    <td>{this.props.user.suburb}</td>
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <b>Postcode</b>
                      </label>
                    </td>
                    <td>
                      <label>:</label>
                    </td>
                    <td>{this.props.user.postcode}</td>
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <b>State</b>
                      </label>
                    </td>
                    <td>
                      <label>:</label>
                    </td>
                    <td>{this.props.user.state}</td>
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <b>Role</b>
                      </label>
                    </td>
                    <td>
                      <label>:</label>
                    </td>
                    <td>{this.props.user.count}</td>
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <b>Date Joined</b>
                      </label>
                    </td>
                    <td>
                      <label>:</label>
                    </td>
                    <td>
                      <Moment
                        format={dateFormat}
                        date={new Date(this.props.user.dateTimeCreated)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>
                      <div className="k-form-buttons">
                        {this.props.isDeleteMode && (
                          <button
                            type={"submit"}
                            className="k-button k-primary"
                            onClick={this.handleDelete}
                            disabled={false}
                          >
                            <div>Delete</div>
                          </button>
                        )}
                        <button
                          type={"submit"}
                          className="k-button"
                          onClick={this.handleClose}
                        >
                          Close
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Dialog>
        </div>
      );
    return <React.Fragment>{userDetail}</React.Fragment>;
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.userReducer.data,
    userPending: state.userReducer.pending,
    states: state.stateReducer.data,
    statesPending: state.stateReducer.pending,
    enterprises:
      state.enterpriseReducer.enterprise == null
        ? []
        : state.enterpriseReducer.enterprise.map((item) => {
          return { id: item.entid1, name: item.name1 };
        }),
    enterprisePending: state.enterpriseReducer.pending,
  };
};

const mapDispatchToProps = {
  getEnterpriseByEmail,
  getUserDetail,
  getState,
};
//export default Instrument;
export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
